import {
  TabList,
  Tab,
  Tabs,
  Flex,
  Box,
  Button,
  Code,
  useToast,
} from "@chakra-ui/react";
import { requestLanguages } from "./requestLanguages";
import "./ApiRequestLanguages.css";
import { useApiPageContext } from "context/ApiPagecontext";
import ApiBlockRequestParams from "../ApiBlockLayout/ApiBlockRequestParams";

const ApiRequestLanguages = () => {
  const {
    selectedLanguage,
    setSelectedLanguage,
    selectedEndpoint,
    setSelectedTool,
    selectedTool,
  } = useApiPageContext();

  const toast = useToast();

  function copyApiRequestExample() {
    const apiRequestExample = document.getElementById("api-request-example");

    if (!apiRequestExample) {
      // console.error('Element with ID "api-request-example" not found.');
      return;
    } else {
      const range = document.createRange();
      range.selectNode(apiRequestExample);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      document.execCommand("copy");

      selection.removeAllRanges();

      toast({
        position: "top",
        title: "Code copied succesfully.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    }
  }

  const selectLanguage = (lang) => {
    setSelectedLanguage(lang);

    requestLanguages.forEach((requestLang) => {
      if (requestLang.name === lang) {
        setSelectedTool(requestLang.languageOptions.GetBalance[0].name);
      }
    });
  };

  return (
    <>
      <Box mb={5}>
        <ApiBlockRequestParams />
      </Box>
      <Tabs className="api-request-languages">
        <TabList className="api-request-languages-tab-list">
          {requestLanguages.map((option) => (
            <Tab key={option.name} onClick={() => selectLanguage(option.name)}>
              <Flex alignItems="center">
                <div className="api-request-icon-wrapper">{option.icon}</div>
                <Box ml={1}>{option.name}</Box>
              </Flex>
            </Tab>
          ))}
        </TabList>
      </Tabs>
      <Flex mt={5} justifyContent="space-between">
        <Box>
          {requestLanguages
            .filter((lang) => lang.name === selectedLanguage)
            .map((item) =>
              item.languageOptions[selectedEndpoint].map((langOption, index) => (
                <Button
                  colorScheme="blue"
                  key={index}
                  size="xs"
                  isActive={selectedTool === langOption.name}
                  onClick={() => setSelectedTool(langOption.name)}
                  className="request-languages-option-button"
                  rounded="none"
                >
                  {langOption.name}
                </Button>
              ))
            )}
        </Box>
        <Box>
          <Button
            size="xs"
            colorScheme="teal"
            onClick={() => copyApiRequestExample()}
          >
            Copy Code
          </Button>
        </Box>
      </Flex>
      <Box mt={5}>
        {requestLanguages
          .filter((lang) => lang.name === selectedLanguage)
          .map((item) =>
            item.languageOptions[selectedEndpoint]
              .filter((languageTool) => languageTool.name === selectedTool)
              .map((tool) => (
                <Code
                  width="100%"
                  p={4}
                  overflowX="auto"
                  key={tool.name}
                  id="api-request-example"
                  position="relative"
                >
                  {tool.content}
                </Code>
              ))
          )}
      </Box>
    </>
  );
};

export default ApiRequestLanguages;
